package com.fireavert.react.shared.components.forms.slider

enum class ValueLabelDisplay(val value: String) {
    ON("on"),
    AUTO("auto"),
    OFF("off");

    companion object {
        fun fromString(value: String): ValueLabelDisplay {
            return when (value.lowercase()) {
                "on" -> ON
                "auto" -> AUTO
                "off" -> OFF
                else -> throw IllegalArgumentException("Unknown ValueLabelDisplay value: $value")
            }
        }
    }
}